import { get, post, put } from '../../../../GlobalModules/Utility/Http';

const PRODUCT_BASE_URL = `${process.env.EXTENDED_URL}product`;
const CATEGORY_BASE_URL = `${process.env.EXTENDED_URL}category`;

/**
 * Fetch products with optional filters
 * @param {Object} filters - Filter parameters for the API call
 * @param {Object} filterOp - Filter operation parameters for the API call
 * @returns {Promise} Processed product list data
 */
export const getProducts = async (filters = {}, filterOp = null) => {
  try {
    // Format filters according to the API structure
    let queryParams = {};
    // console.log('filters--->', filters)
    // console.log('filterOp--->', filterOp)
    
    if (filters) {
      // Create filter object
      const filtersObj = {
        limit: filters.limit || 100,
        offset: filters.offset || 0,
        store_id: filters.store_id || localStorage.getItem('store_id') || "",
        is_ingredient: filters.is_ingredient !== undefined ? filters.is_ingredient : 0,
        is_addon_product: filters.is_addon_product !== undefined ? filters.is_addon_product : 0,
        status: 1
      };

      // Handle category filter
      if (filters.category_id && Array.isArray(filters.category_id) && filters.category_id.length > 0) {
        filtersObj.category_id = filters.category_id;
      }

      // Handle search term - support both old 'search' and new 'search_attr'
      if (filters.search) {
        queryParams.filter_op = JSON.stringify({ search_attr: "substring" });
        filtersObj.search_attr = filters.search;
      } else if (filters.search_attr) {
        // New search_attr parameter support
        filtersObj.search_attr = filters.search_attr;
        
        // Add filter_op if provided
        if (filterOp) {
          queryParams.filter_op = JSON.stringify(filterOp);
        } else {
          queryParams.filter_op = JSON.stringify({ search_attr: "substring" });
        }
      }

      queryParams.filters = JSON.stringify(filtersObj);
    }

    const response = await get(`${PRODUCT_BASE_URL}/list`, queryParams);

    if (!response || !response.data || !response.data.success) {
      return {
        success: false,
        message: response?.data?.message || 'Failed to fetch products',
        data: []
      };
    }

    return {
      success: true,
      message: response.data.message || 'Products fetched successfully',
      data: response.data.data || []
    };
  } catch (error) {
    console.error('Error fetching products:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Failed to fetch products',
      data: []
    };
  }
};

/**
 * Fetch product categories
 * @returns {Promise} Processed category list data
 */
export const getCategories = async () => {
  try {
    const filtersObj = {
      store_id: localStorage.getItem('store_id'),
      display_on_pos_screen: 1
    };
    const queryParams = {
      filters: JSON.stringify(filtersObj)
    };
    const response = await get(`${CATEGORY_BASE_URL}`, queryParams);

    if (!response || !response.data || !response.data.success) {
      return {
        success: false,
        message: response?.data?.message || 'Failed to fetch categories',
        data: []
      };
    }

    return {
      success: true,
      message: response.data.message || 'Categories fetched successfully',
      data: response.data.data || []
    };
  } catch (error) {
    console.error('Error fetching categories:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Failed to fetch categories',
      data: []
    };
  }
};

/**
 * Get product details by slack
 * @param {string} slack - Product slack
 * @returns {Promise} Product details
 */
export const getProductDetails = async (slack) => {
  try {
    const response = await get(`${PRODUCT_BASE_URL}/${slack}`);

    if (!response || !response.data || !response.data.success) {
      return {
        success: false,
        message: response?.data?.message || 'Failed to fetch product details',
        data: null
      };
    }

    return {
      success: true,
      message: response.data.message || 'Product details fetched successfully',
      data: response.data.data || null
    };
  } catch (error) {
    console.error('Error fetching product details:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Failed to fetch product details',
      data: null
    };
  }
};

/**
 * Get product add-ons by product slack
 * @param {string} slack - Product slack
 * @returns {Promise} Product add-ons list
 */
export const getProductAddons = async (productSlack) => {
  try {
    const response = await get(`${PRODUCT_BASE_URL}/${productSlack}/addons`);

    if (!response || !response.data || !response.data.success) {
      return {
        success: false,
        message: response?.data?.message || 'Failed to fetch product add-ons',
        data: []
      };
    }

    return {
      success: true,
      message: response.data.message || 'Product add-ons fetched successfully',
      data: response.data.data || []
    };
  } catch (error) {
    console.error('Error fetching product add-ons:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Failed to fetch product add-ons',
      data: []
    };
  }
};

export default {
  getProducts,
  getCategories,
  getProductDetails,
  getProductAddons
};
